// extracted by mini-css-extract-plugin
module.exports = {"floatLeft":"getFloat_floatLeft__2oOre","floatRight":"getFloat_floatRight__19Ofu","floatNone":"getFloat_floatNone__1qmwq"};